export default {
      id: "user-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#user",
      toString: function () {
        return this.url;
      }
    }